import GuardianshipStatementModal from './GuardianshipStatementModal';
export default GuardianshipStatementModal;
